import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  backgroundColor() {
    return faker.color.rgb({ prefix: '#' });
  },

  embedId() {
    return faker.random.alphaNumeric(5);
  },

  headline() {
    return faker.music.songName();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(mediaEmbed, server) {
    mediaEmbed.update({
      backgroundImage: server.create('asset'),
      channels: server.createList('channel', 2),
      embedService: server.create('category', 'embedService'),
    });
  },
});
